module.exports = __webpack_public_path__ + "static/img/buyTip.32c335c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listdetail/buyTip.png
// module id = X+/c
// module chunks = 0